export default "__VITE_ASSET__a402844c__"